import { Injectable } from '@angular/core';
import { LoginModel } from '../model/login.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageService } from './localstorage.service';
import { Observable, catchError, of, tap } from 'rxjs';
import { IArquiveiModel, IConsultaArquiveiModel, IConsultaConfiguracaoNFe, IConsultaParametroConciliacaoModel, IConsultaParametroReagendamentoModel, IParametroConciliacao, IParametroReagendamento, IRetornoConfiguracaoModel } from '../model/configuracaoNFe.model';
import { environment } from 'src/environments/environment';
import { SnackBarService } from './snack-bar-service.service';
import { CONFIG_URLS_API } from 'src/environments/config-envs';

@Injectable({
  providedIn: 'root'
})
export class NotafiscalService {

  public usuario!: LoginModel;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  
  constructor(private http: HttpClient,
    private localStorageService: LocalStorageService,
    private snackBar: SnackBarService) {

    var userData = this.localStorageService.getItem('userData');

    if (userData != null) {
      this.usuario = JSON.parse(userData);
    }
  }

  getArquivei(filtro: IConsultaConfiguracaoNFe): Observable<IConsultaArquiveiModel> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ConsultaArquivei;

    return this.http.post<IConsultaArquiveiModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar as configurações da Arquivei.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IConsultaArquiveiModel>('Não foi possível consultar as configurações da Arquivei.', {sucesso : false, retorno: undefined, mensagens: []}))
    );
  }

  cancelarArquivei(arquivei: IConsultaConfiguracaoNFe): Observable<IRetornoConfiguracaoModel> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_CancelarArquivei;

    return this.http.post<IRetornoConfiguracaoModel>(url, arquivei, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível cancelar a Arquivei.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IRetornoConfiguracaoModel>('Não foi possível cancelar a Arquivei.', {sucesso : false, retorno: false, mensagens: []}))
    );
  }

  getParametroReagendamento(filtro: IConsultaConfiguracaoNFe): Observable<IConsultaParametroReagendamentoModel> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ConsultaParametroReagendamento;

    return this.http.post<IConsultaParametroReagendamentoModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar os parâmetros do Reagendamento.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IConsultaParametroReagendamentoModel>('Não foi possível consultar os parâmetros do Reagendamento.', {sucesso : false, retorno: undefined, mensagens: []}))
    );
  }

  alterarParametroReagendamento(parametroReagendamento: IParametroReagendamento): Observable<IRetornoConfiguracaoModel> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_AlterarParametroReagendamento;

    return this.http.post<IRetornoConfiguracaoModel>(url, parametroReagendamento, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível alterar os parâmetros do Reagendamento.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IRetornoConfiguracaoModel>('Não foi possível alterar os parâmetros do Reagendamento.', {sucesso : false, retorno: false, mensagens: []}))
    );
  }

  getParametroConciliacao(filtro: IConsultaConfiguracaoNFe): Observable<IConsultaParametroConciliacaoModel> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_ConsultaParametroConciliacao;

    return this.http.post<IConsultaParametroConciliacaoModel>(url, filtro, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível consultar os parâmetros da Conciliação.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IConsultaParametroConciliacaoModel>('Não foi possível consultar os parâmetros da Conciliação.', {sucesso : false, retorno: undefined, mensagens: []}))
    );
  }

  alterarParametroConciliacao(parametroReagendamento: IParametroConciliacao): Observable<IRetornoConfiguracaoModel> {
    const url = environment.host_ctf_service+ CONFIG_URLS_API.API_AlterarParametroConciliacao;

    return this.http.post<IRetornoConfiguracaoModel>(url, parametroReagendamento, this.httpOptions).pipe(
      tap(response => {
        if (response && !response.sucesso) {
          this.snackBar.flashMessage('Não foi possível alterar os parâmetros da Conciliação.', ['snackbar-error'], 'Fechar', 0);
        }
      }),
      catchError(this.handleError<IRetornoConfiguracaoModel>('Não foi possível alterar os parâmetros da Conciliação.', {sucesso : false, retorno: false, mensagens: []}))
    );
  }

  private handleError<T>(mensagem = 'Não foi possível realizar a operação.', result?: T) {
    return (error: any): Observable<T> => {

      this.snackBar.flashMessage(mensagem, ['snackbar-error'], 'Fechar', 0);

      return of(result as T);
    };
  }
  
}
